import moment from 'moment'
import { AnyAction } from 'redux'
import { Actions } from '../actions/news'
import { NewsState } from '../states/newsState'
import {
    News,
    NewsComment,
    NewsReaction,
    NewsTabBarId,
} from '@models/news'
import { formatDate } from '@utils/commonFunctions'

export const ROOT_PAGE_NUM = 'root'
export const NEWS_REDUCER_NAMESPACE = 'newsReducer'

const shuffle = (array) => {
    let currentIndex = array.length,
        randomIndex
    // While there remain elements to shuffle.
    while (currentIndex != 0) {
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex--
        // And swap it with the current element.
        ;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
    }

    return array
}

/*
const news1 = `${process.env.SMARTLY_URL}/styleguide/assets/images/news-1.jpg`
const news2 = `${process.env.SMARTLY_URL}/styleguide/assets/images/news-2.png`
const avatarImg = `${process.env.SMARTLY_URL}/styleguide/assets/images/user-avatar.png`

const DUMMY_NEWS_COMMENTS_LIST: NewsComment[] = [
    {
        id: 1,
        author: {
            name: 'Federica',
            lastname: 'Testa',
            avatar: avatarImg,
            nickname: 'FTesta',
        },
        comment:
            'Lorem ipsum dolor sit. Ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod dolor sit. Ipsum dolor sit amet, !!',
        creationDate: moment().format(dateFormat),
        reactions: {
            total: 3,
            typeList: [NewsReactionType.THUMB, NewsReactionType.FACE_HEART, NewsReactionType.FACE],
        },
    },
    {
        id: 2,
        author: {
            name: 'Gabriele',
            lastname: 'Rispoli',
            nickname: 'Grispoli',
        },
        comment: 'Lorem ipsum dolor 👏👏',
        creationDate: moment('09/04/2022').format(dateFormat),
        reactions: {
            total: 0,
            typeList: [],
        },
    },
]

const DUMMY_NEWS: News[] = [
    {
        id: 1,
        author: {
            name: 'Gabriele',
            lastname: 'Rispoli',
            nickname: 'Grispoli',
        },
        creationDate: moment().format(dateFormat),
        type: NewsType.COMMUNICATION,
        typeKey: 'communication',
        title: 'Title',
        content:
            'Sunglass Hut News has a new home right here on Store 360 - Communications, making it easy for you to stay in the know of all things Sunglass Hut. Sunglass Hut News has a new home right here on Store 360 - Communications, making it easy for you to stay in the know of all things Sunglass Hut. Sunglass Hut News has a new home right here on Store 360 - Communications, making it easy for you to stay in the know of all things Sunglass Hut. Sunglass Hut News has a new home right here on Store 360 - Communications, making it easy for you to stay in the know of all things Sunglass Hut.',
        hashtagList: ['gatekeepertopic', 'sunglasshut', 'news'],
        imageList: [news1],
        totalComments: 34,
        reactions: {
            total: 36,
            typeList: [
                NewsReactionType.THUMB,
                NewsReactionType.FACE_HEART,
                NewsReactionType.HEART,
                NewsReactionType.FACE,
            ],
        },
        commentsList: DUMMY_NEWS_COMMENTS_LIST,
    },
    {
        id: 2,
        author: {
            name: 'Federica',
            lastname: 'Testa',
            avatar: avatarImg,
            nickname: 'FTesta',
        },
        creationDate: moment('07/24/2022').format(dateFormat),
        type: NewsType.STORE_VISIT_TOOL,
        typeKey: 'store.visit.tool',
        title: 'Store Visit',
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Up to 200 characters.',
        hashtagList: ['storevisit', 'sunglasshut', 'news'],
        imageList: [news1, news2],
        totalComments: 45,
        reactions: {
            total: 24,
            typeList: [NewsReactionType.FACE_HEART, NewsReactionType.HEART],
        },
    },
    {
        id: 3,
        author: {
            name: 'Filippo',
            lastname: 'Testa',
            nickname: 'FilTesta',
        },
        creationDate: moment().format(dateFormat),
        type: NewsType.PICTURE_MANAGMENT,
        typeKey: 'picture.managment',
        title: 'Store Visit',
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Up to 200 characters.',
        hashtagList: ['picturemanagment', 'sunglasshut', 'news'],
        imageList: [news1],
        totalComments: 45,
        reactions: {
            total: 36,
            typeList: [NewsReactionType.THUMB, NewsReactionType.FACE_HEART, NewsReactionType.HEART],
        },
    },
    {
        id: 4,
        author: {
            name: 'Gabriele',
            lastname: 'Rispoli',
            nickname: 'Grispoli',
        },
        creationDate: moment().format(dateFormat),
        type: NewsType.SURVEY,
        typeKey: 'survey',
        title: 'Store Visit',
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Up to 200 characters.',
        hashtagList: ['survey', 'sunglasshut', 'news'],
        imageList: [news1],
        totalComments: 45,
        reactions: {
            total: 0,
            typeList: [],
        },
    },
]

const tabBarConfiguration: TabBar[] = [
    {
        id: NewsTabBarId.ALL,
        name: 'All',
        keyName: 'home.activity.tab.all',
    },
    {
        id: NewsTabBarId.YESTERDAY,
        name: 'Yesterday',
        keyName: 'home.activity.tab.yesterday',
    },
    {
        id: NewsTabBarId.LAST_WEEK,
        name: 'Last week',
        keyName: 'home.activity.tab.last.week',
    },
    {
        id: NewsTabBarId.LAST_MONTH,
        name: 'Last month',
        keyName: 'home.activity.tab.last.month',
    },
]
*/

const defaultState: NewsState = {
    newsList: [],
    loading: true,
    activeTab: NewsTabBarId.CURRENT_WEEK,
    tabBarConfiguration: [
        {
            id: NewsTabBarId.CURRENT_WEEK,
            name: 'Current week',
            keyName: 'home.activity.tab.current.week',
        },
        {
            id: NewsTabBarId.LAST_WEEK,
            name: 'Last week',
            keyName: 'home.activity.tab.last.week',
        },
        {
            id: NewsTabBarId.CURRENT_MONTH,
            name: 'Current month',
            keyName: 'home.activity.tab.current.month',
        },
        {
            id: NewsTabBarId.ALL,
            name: 'All',
            keyName: 'home.activity.tab.all',
        }
    ],
    newsDetails: null,
    showNewsDetails: false,
    filters: {
        page: 1,
        page_size: 10,
        type: {
            value: ['news'],
        },
        start_date: {
            value: `${formatDate(
                moment().startOf('isoWeek').toString(),
                'YYYY-MM-DD'
            )} 00:00`,
            orderBy: 'DESC',
        },
        end_date: {
            value: `${formatDate(
                moment().endOf('isoWeek').toString(),
                'YYYY-MM-DD'
            )} 00:00`
        },
        useIntervalDate: true,
        more_information: true,
    },
    loadingReactions: {},
    totalNews: 0,
}

export default (state: NewsState = defaultState, action: AnyAction) => {
    let newsListUpdated: News[], index: number, commentIndex: number, commentsList: NewsComment[]
    switch (action.type) {
        case Actions.GET_NEWS_REQUEST:
            return {
                ...state,
                newsList: [],
                totalNews: 0,
                loading: true,
            }
        case Actions.GET_MORE_NEWS_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case Actions.GET_NEWS_SUCCESS:
            return {
                ...state,
                newsList: action.news,
                totalNews: action.totalNews,
                loading: false,
            }
        case Actions.GET_MORE_NEWS_SUCCESS:
            return {
                ...state,
                newsList: [...state.newsList, ...action.news],
                totalNews: action.totalNews,
                loading: false,
            }
        case Actions.SET_NEWS_REACTION_REQUEST:
            return {
                ...state,
                loadingReactions: { ...state.loadingReactions, [action.newsId]: true },
            }
        case Actions.SET_NEWS_REACTION_FAILURE:
            return {
                ...state,
                loadingReactions: { ...state.loadingReactions, [action.newsId]: false },
            }
        case Actions.GET_NEWS_DETAIL_SUCCESS:
            let _newsList = [...state.newsList]
            let newNewsIdx = _newsList.findIndex((n) => n.id === action.newsId)
            if (newNewsIdx !== undefined) _newsList[newNewsIdx].reactions = action.newsReactions

            return {
                ...state,
                newsList: _newsList,
                loadingReactions: { ...state.loadingReactions, [action.newsId]: false },
            }
        case Actions.GET_NEWS_FAILURE:
            return {
                ...state,
                news: [],
                totalNews: 0,
                loading: false,
            }
        case Actions.GET_MORE_NEWS_FAILURE:
            return {
                ...state,
                loading: false,
            }
        case Actions.SET_FILTERS:
            return {
                ...state,
                filters: {...action.filters},
            }
        case Actions.SET_ACTIVE_TAB:
            return {
                ...state,
                activeTab: action.activeTab,
            }
        case Actions.UPDATE_TOTAL_REACTIONS:
            newsListUpdated = [...state.newsList]
            index = newsListUpdated.findIndex((news) => news.id === action.payload.newsId)
            if (!!action.payload.commentId) {
                commentsList = newsListUpdated[index].commentsList
                    ? [...newsListUpdated[index].commentsList]
                    : []
                commentIndex = commentsList.findIndex(
                    (comment) => comment.id === action.payload.commentId
                )
                commentsList[commentIndex].reactions =
                    commentsList[commentIndex].reactions || <NewsReaction>{}
                if (!commentsList[commentIndex].reactions.userReaction) {
                    commentsList[commentIndex].reactions.count++
                }
                commentsList[commentIndex].reactions = {
                    ...commentsList[commentIndex].reactions,
                    userReaction: action.payload.type,
                }
                newsListUpdated[index].commentsList = [...commentsList]
            } else {
                let newReaction = newsListUpdated[index].reactions
                    ? { ...newsListUpdated[index].reactions }
                    : <NewsReaction>{}
                if (!newsListUpdated[index].reactions.userReaction) {
                    newReaction.count = newsListUpdated[index].reactions.count + 1
                }
                newReaction.userReaction = action.payload.type
                newsListUpdated[index].reactions = { ...newReaction }
            }
            return {
                ...state,
                newsList: [...newsListUpdated],
            }
        case Actions.ADD_COMMENT:
            newsListUpdated = [...state.newsList]
            index = newsListUpdated.findIndex((news) => news.id === action.payload.newsId)
            commentsList = newsListUpdated[index].commentsList
                ? [...newsListUpdated[index].commentsList]
                : []
            if (!!action.payload.commentId) {
                commentIndex = commentsList.findIndex(
                    (comment) => comment.id === action.payload.commentId
                )
                const childrenCommentsList = commentsList[commentIndex].replyList
                    ? [...commentsList[commentIndex].replyList]
                    : []
                commentsList[commentIndex].replyList = [
                    ...childrenCommentsList,
                    action.payload.comment,
                ]
                newsListUpdated[index].commentsList = [...commentsList]
            } else {
                newsListUpdated[index].commentsList = [action.payload.comment, ...commentsList]
            }
            return {
                ...state,
                newsList: [...newsListUpdated],
                newsDetails: { ...newsListUpdated[index] },
            }
        case Actions.SET_NEWS_DETAILS:
            return {
                ...state,
                newsDetails: { ...action.newsDetails },
                showNewsDetails: !state.showNewsDetails,
            }
        case Actions.ORDER_RANDOM_NEWS:
            const newsList = [...shuffle(state.newsList)]
            return {
                ...state,
                newsList,
            }
        default:
            return {
                ...state,
            }
    }
}
